<template>
  <div>
    <!--     Window height: {{ windowHeight }} <br />
    Window width: {{ windowWidth }} <br /> -->

    <template v-if="this.dataTableItems != null || this.stations != null">
      <template v-if="this.station === null">
        <v-row no-gutters>
          <v-col cols="8" class="ma-2">
            <h2 class="mx-4">{{ $t("charger.header") }}</h2>
          </v-col>
          <v-spacer />
          <v-col cols="2" class="ma-2">
            <template v-if="this.tableView">
              <v-btn fab small raised color="primary" elevation="12" @click="setChargersTableView(false)">
                <v-icon>mdi-card-text-outline</v-icon>
              </v-btn>
            </template>

            <template v-else>
              <v-btn fab small raised color="primary" elevation="12" @click="setChargersTableView(true)">
                <v-icon>mdi-table</v-icon>
              </v-btn>
            </template>
          </v-col>
        </v-row>

        <template v-if="this.tableView">
          <v-row>
            <v-col cols="12">
              <!--               <v-card elevation="6">
                <v-card-title>
                  <v-col cols="12" md="8">
                    <h3>{{ $t("charger.sessions") }}</h3>
                  </v-col>

                  <v-spacer />
                  <v-col cols="10" md="2">
                    <v-text-field
                      v-model="dataTableSearch"
                      :label="$t('charger.search')"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="2" md="2" class="mt-4">
                    <v-icon>mdi-magnify</v-icon>
                  </v-col>
                </v-card-title> -->

              <!-- :item-style="getStationsRowStyles"  -->
              <v-data-table :headers="dataTableChargersHeader" :items="dataTableChargersItems" :locale="`${$i18n.locale}`" calculate-widths loading="true" :sort-desc="true" :items-per-page="5" @click:row="handleClick" :mobile-breakpoint="0">
                <template v-slot:[`item.name`]="{ item }">
                  <v-chip outlined color="cyan darken-2" dark>
                    <b>{{ item.name }}</b>
                  </v-chip>
                </template>

                <template v-slot:[`item.stateDesc`]="{ item }">
                  <v-chip outlined :color="$vuetify.theme.dark ? '#B8FB3C' : 'green'" dark>
                    <b>{{ item.stateDesc != "" ? $t("charger.stateDesc." + item.stateDesc) : "" }}</b>
                  </v-chip>
                </template>

                <template v-slot:[`item.power`]="{ item }">
                  <v-chip outlined color="#7122FA" dark>
                    <b>{{ item.power }}</b>
                  </v-chip>
                </template>

                <template v-slot:[`item.energy`]="{ item }">
                  <v-chip outlined color="#440BD4" dark>
                    <b>{{ item.energy }}</b>
                  </v-chip>
                </template>

                <template v-slot:[`item.durationTime`]="{ item }">
                  <v-chip outlined color="#F148FB" dark>
                    <b>{{ item.durationTime.h }}:{{ item.durationTime.m }}:{{ item.durationTime.s }} </b>
                  </v-chip>
                </template>

                <template v-slot:[`item.serialNumber`]="{ item }">
                  <v-chip outlined color="#FF2079" dark>
                    <b>{{ item.serialNumber }}</b>
                  </v-chip>
                </template>
              </v-data-table>
              <!--               </v-card> -->
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-slide-group show-arrows="always" active-class="success" class="my-2">
            <v-row justify="center">
              <v-slide-item v-for="station in stations.units" :key="station.unitId">
                <v-hover v-slot="{ hover }">
                  <v-card :disabled="station.stateDesc == 'InUse' ? true : false" :elevation="hover ? 12 : 6" :dark="$vuetify.theme.dark" @click="getStation(station.unitId)" class="ma-4" height="220" width="400" :max-width="stationCardMaxWidth">
                    <v-expand-transition>
                      <div v-if="hover" class="d-flex transition-fast-in-fast-out primary v-card--reveal headline white--text" style="height: 100%">
                        {{ $t("charger.hover") }}
                      </div>
                    </v-expand-transition>
                    <v-card-title class="white--text primary">
                      {{ station.name }}

                      <v-spacer />
                      <v-icon class="shadow" large color="white">mdi-ev-station</v-icon>
                    </v-card-title>

                    <v-card-text>
                      <template v-if="!hover">
                        <v-row class="ma-2">
                          <div class="ml-2">
                            {{ $t("charger.state") }}:
                            <b>{{ station.stateDesc != "" ? $t("charger.stateDesc." + station.stateDesc) : "" }}</b>
                          </div>
                        </v-row>

                        <template v-if="'power' in station">
                          <div class="caption">
                            {{ $t("charger.power") }}:
                            <b>{{ station.power }} kW </b>
                          </div>
                        </template>
                        <template v-else>
                          <br />
                        </template>

                        <template v-if="'energy' in station">
                          <div class="caption">
                            {{ $t("charger.energy") }}:
                            <b>{{ station.energy }} kWh</b>
                          </div>
                        </template>
                        <template v-else>
                          <br />
                        </template>

                        <template v-if="'durationTime' in station">
                          <div class="caption">
                            {{ $t("charger.durationTime") }}:
                            <b>{{ station.durationTime.h + ":" + station.durationTime.m + ":" + station.durationTime.s + " h" }}</b>
                          </div>
                        </template>
                        <template v-else>
                          <br />
                        </template>

                        <template v-if="'serialNumber' in station">
                          <div class="overline mt-4 d-flex float-right">
                            {{ $t("charger.serialNumber") }}: <b>{{ station.serialNumber }}</b> <br />
                          </div>
                        </template>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-slide-item>
            </v-row>
          </v-slide-group>
        </template>

        <v-row class="ma-2">
          <v-col cols="12"
            ><h3>{{ $i18n.t("charger.measure") }}:</h3></v-col
          >

          <v-col cols="12" md="auto">
            <v-row>
              <v-col cols="auto"> {{ $i18n.t("charger.totalConsumingPower") }}:</v-col>
              <v-col cols="auto">
                <b>{{ totalConsumingPower }} kW </b>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="auto">
            <v-row>
              <v-col cols="auto"> {{ $i18n.t("charger.totalChargingPower") }}:</v-col>
              <v-col cols="auto"
                ><b>{{ totalChargingPower }} kW </b>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card elevation="6">
          <v-card-title>
            <v-col cols="12" md="8">
              <h3>{{ $t("charger.sessions") }}</h3>
            </v-col>

            <v-spacer />
            <v-col cols="10" md="2">
              <v-text-field v-model="dataTableSearch" :label="$t('charger.search')" single-line hide-details></v-text-field>
            </v-col>

            <v-col cols="2" md="2" class="mt-4">
              <v-icon>mdi-magnify</v-icon>
            </v-col>
          </v-card-title>

          <v-data-table :headers="dataTableHeaders" :items="dataTableItems" :locale="`${$i18n.locale}`" calculate-widths loading="true" :sort-desc="true" :items-per-page="5" :search="dataTableSearch">
            <template v-slot:[`item.energy`]="{ item }">
              <v-chip outlined color="red darken-2" dark>
                <b>{{ item.energy }}</b>
              </v-chip>
            </template>

            <template v-slot:[`item.durationTime`]="{ item }">
              <v-chip outlined color="orange darken-2" dark>
                <b>{{ item.durationTime }}</b>
              </v-chip>
            </template>

            <template v-slot:[`item.name`]="{ item }">
              <v-chip outlined color="cyan darken-2" dark>
                <b>{{ item.name }}</b>
              </v-chip>
            </template>

            <template v-slot:[`item.initialEnergy`]="{ item }">
              <v-chip outlined color="blue darken-2" dark>
                <b>{{ item.initialEnergy }}</b>
              </v-chip>
            </template>

            <!--             <template v-slot:[`item.flagsDesc`]="{ item }">
              <v-chip outlined dark :color="getFlagsDescColor(item)">
                <b>{{ item.flagsDesc }}</b>
              </v-chip>
            </template> -->

            <template v-slot:[`item.flagsDesc`]="{ item }">
              <v-chip outlined dark :color="getFlagsDescColor(item)">
                <b>{{ item.flagsDesc2 }}</b>
              </v-chip>
            </template>

            <!-- this.dataTableItems[index].enabled = true; // enabled -->

            <template v-slot:[`item.confirm`]="{ item }">
              <template v-if="account.user.roles[1] == 'EVC_ADMIN'">
                <v-btn :disabled="account.user.roles[1] != 'EVC_ADMIN'" fab dark small :color="getConfirmColor(item)" @click="toggleConfirm(item)">
                  <v-icon dark>mdi-check-bold</v-icon>
                </v-btn>
              </template>
            </template>
          </v-data-table>
        </v-card>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="2" align="start">
            <v-btn fab small raised color="primary" elevation="12" @click="resetStation()"><v-icon>mdi-keyboard-backspace</v-icon></v-btn>
          </v-col>

          <v-col cols="8" align="center">
            <template v-if="this.chargingControl.iddle">
              <v-btn :loading="true" :disabled="true" class="ma-2 white--text" color="light-green" elevation="12">
                Iddle
                <v-icon right dark>mdi-play</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <template v-if="this.chargingControl.start">
                <v-btn class="ma-2 white--text" @click="sendCommand()" color="light-green" elevation="12">
                  Start
                  <v-icon right dark>mdi-play</v-icon>
                </v-btn>
              </template>

              <template v-if="this.chargingControl.stop">
                <v-btn class="ma-2 white--text" @click="sendCommand()" color="red accent-4" elevation="12">
                  Stop
                  <v-icon right dark>mdi-stop</v-icon>
                </v-btn>
              </template>
            </template>
          </v-col>
        </v-row>

        <template v-if="this.data != null">
          <template v-if="this.mobile == true">
            <v-row class="text-center" justify="center">
              <v-col cols="8" align="end">
                <ChargerGauge :showEnergy="'powerDC' in data ? false : true" :value2="'powerDC' in data ? data.session.carSOC : data.session.energy" :max="this.maximumPower" :value="this.data.energyP.power" :percentage="'energyP' in this.data ? this.svgGaugeData.value : 0" :color="this.color1" />
              </v-col>
            </v-row>
          </template>
        </template>

        <template v-if="this.data != null">
          <v-row class="justify-center align-center">
            <v-col cols="12">
              <v-row class="text-center" justify="center">
                <v-col cols="4" align="center">
                  <v-icon v-bind:style="currentSizeIcons" class="shadow" :color="getColor()"> mdi-ev-station </v-icon>
                </v-col>

                <template v-if="this.mobile == false">
                  <v-col cols="4" align="center">
                    <ChargerGauge
                      :showEnergy="'powerDC' in data ? false : true"
                      :value2="'powerDC' in data ? data.session.carSOC : data.session.energy"
                      :max="this.maximumPower"
                      :value="this.data.energyP.power"
                      :percentage="'energyP' in this.data ? this.svgGaugeData.value : 0"
                      :color="this.color1"
                    />
                  </v-col>
                </template>

                <template v-else>
                  <v-col cols="4" align="center">
                    <template v-if="'energyP' in this.data && Math.abs(this.data.energyP.power) > 0">
                      <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="Math.abs(this.data.energyP.power) > 0 ? ('carSOC' in data.session ? data.session.carSOC : 100) : 0" :Charging="true" :ChargingRate="this.data.energyP.power" :PrimaryColor="true"></BatterySoC>
                    </template>
                    <template v-else>
                      <template v-if="'carSOC' in data.session && this.data.session.carSOC != 0">
                        <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="this.data.session.carSOC" :Charging="false" :ChargingRate="100" :Unknown="false" :PrimaryColor="true"></BatterySoC>
                      </template>

                      <template v-else>
                        <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="100" :Charging="true" :ChargingRate="100" :Unknown="true" :PrimaryColor="true"></BatterySoC>
                      </template>
                    </template>
                  </v-col>
                </template>

                <v-col cols="4" align="center">
                  <v-icon v-bind:style="currentSizeIcons" :color="getColor()" class="shadow" ref="evcgauge"> mdi-car </v-icon>
                </v-col>
              </v-row>

              <template v-if="!this.mobile">
                <template v-if="'energyP' in this.data && Math.abs(this.data.energyP.power) > 0">
                  <v-row class="text-center animationCharge arrows" justify="center">
                    <v-col cols="8">
                      <v-icon class="pb-4 mb-4 shadow" v-bind:style="currentSizeArrows" :color="getColor()" v-for="arrow in arrows.value" v-bind:key="arrow"> mdi-arrow-right </v-icon>
                    </v-col>
                  </v-row>
                </template>

                <template v-else>
                  <v-row class="text-center animationNoCharge arrows" justify="center">
                    <v-col cols="8">
                      <v-icon class="pb-4 mb-4 shadow" v-bind:style="currentSizeArrows" :color="getColor()" v-for="arrow in arrows.value" v-bind:key="arrow"> mdi-minus </v-icon>
                    </v-col>
                  </v-row>
                </template>
              </template>

              <v-row justify="center" class="text-center">
                <v-col cols="12" md="4">
                  <v-simple-table dense :dark="$vuetify.theme.dark" :class="$vuetify.theme.dark ? 'darkTable' : 'lightTable'">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.state") }}</td>
                          <td class="tableTdHalf">
                            <b>{{ data.logic.stateDesc != "" ? $t("charger.stateDesc." + data.logic.stateDesc) : "" }}</b>
                          </td>
                        </tr>

                        <template v-if="data.logic.error != 0">
                          <tr>
                            <td class="tableTdHalf">
                              {{ $t("charger.error") }}
                            </td>
                            <td class="tableTdHalf">
                              <b>{{ data.logic.error }}</b>
                            </td>
                          </tr>
                        </template>
                        <template v-else> </template>

                        <template v-if="data.logic.error2 != 0">
                          <tr>
                            <td class="tableTdHalf">
                              {{ $t("charger.error") }}
                            </td>
                            <td class="tableTdHalf">
                              <b>{{ data.logic.error2 }}</b>
                            </td>
                          </tr>
                        </template>
                        <template v-else> </template>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <br />

                  <v-simple-table dense :dark="$vuetify.theme.dark" :class="$vuetify.theme.dark ? 'darkTable' : 'lightTable'">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <td></td>
                          <td>
                            {{ $t("charger.table.voltage") }}
                          </td>
                          <td>
                            {{ $t("charger.table.current") }}
                          </td>
                          <td>
                            {{ $t("charger.table.power") }}
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="'powerDC' in data">
                          <tr>
                            <td>
                              {{ $t("charger.table.dc") }}
                            </td>

                            <td>
                              <b>{{ data.powerDC.u }} V</b>
                            </td>

                            <td>
                              <b>{{ data.powerDC.i }} A</b>
                            </td>

                            <td>
                              <b>{{ data.powerDC.power }} kW</b>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td>{{ $t("charger.table.phase") }} 1</td>

                            <td>
                              <b>{{ data.powerP1.u }} V</b>
                            </td>

                            <td>
                              <b>{{ data.powerP1.i }} A</b>
                            </td>

                            <td>
                              <b>{{ data.powerP1.power }} kW</b>
                            </td>
                          </tr>

                          <tr>
                            <td>{{ $t("charger.table.phase") }} 2</td>

                            <td>
                              <b>{{ data.powerP2.u }} V</b>
                            </td>

                            <td>
                              <b>{{ data.powerP2.i }} A</b>
                            </td>

                            <td>
                              <b>{{ data.powerP2.power }} kW</b>
                            </td>
                          </tr>

                          <tr>
                            <td>{{ $t("charger.table.phase") }} 3</td>
                            <td>
                              <b>{{ data.powerP3.u }} V</b>
                            </td>

                            <td>
                              <b>{{ data.powerP3.i }} A</b>
                            </td>

                            <td>
                              <b>{{ data.powerP3.power }} kW</b>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <br />
                </v-col>
                <template v-if="this.mobile == false">
                  <v-col cols="12" md="4">
                    <template v-if="'energyP' in this.data && Math.abs(this.data.energyP.power) > 0">
                      <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="Math.abs(this.data.energyP.power) > 0 ? ('carSOC' in data.session ? data.session.carSOC : 100) : 0" :Charging="true" :ChargingRate="this.data.energyP.power" :PrimaryColor="true"></BatterySoC>
                    </template>
                    <template v-else>
                      <template v-if="'carSOC' in data.session && this.data.session.carSOC != 0">
                        <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="this.data.session.carSOC" :Charging="false" :ChargingRate="100" :Unknown="false" :PrimaryColor="true"></BatterySoC>
                      </template>

                      <template v-else>
                        <BatterySoC class="text-center" :size="this.currentSizeIcons.size" :SoC="100" :Charging="true" :ChargingRate="100" :Unknown="true" :PrimaryColor="true"></BatterySoC>
                      </template>
                    </template>
                  </v-col>
                </template>

                <v-col cols="12" md="4">
                  <template v-if="currentParameters.maxUserCurrent != 0">
                    {{ $t("charger.parameterUsrChargingI") }}

                    <v-slider
                      dense
                      v-model="currentParameters.maxUserCurrent"
                      @click="stopTimerStation"
                      @change="sendCurrent(currentParameters.maxUserCurrent)"
                      class="mt-12 mx-4"
                      thumb-color="primary"
                      :thumb-size="42"
                      :min="6"
                      :max="currentParameters.maxCurrent < 6 ? 32 : currentParameters.maxCurrent"
                      :step="1"
                      thumb-label="always"
                      thumb-label-content="true"
                    >
                      <template v-slot:thumb-label="{ value }">
                        <span>{{ value }} A</span>
                      </template>
                    </v-slider>
                  </template>

                  <v-simple-table dense :class="$vuetify.theme.dark ? 'darkTable' : 'lightTable'">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.totalPower") }}:</td>
                          <td class="tableTdHalf">
                            <b>{{ data.energyP.power }} kW</b>
                          </td>
                        </tr>

                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.sessionEnergy") }}:</td>
                          <td class="tableTdHalf">
                            <b>{{ data.session.energy }} kWh </b>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <br />

                  <v-simple-table dense :dark="$vuetify.theme.dark" :class="$vuetify.theme.dark ? 'darkTable' : 'lightTable'">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.chargingStarted") }}:</td>
                          <td class="tableTdHalf">
                            <b>{{ data.session.initialDateTime }}</b>
                          </td>
                        </tr>

                        <template v-if="'remainingTime' in data.session">
                          <tr>
                            <td class="tableTdHalf">{{ $t("charger.remainingTime") }}:</td>
                            <td class="tableTdHalf">
                              <b> {{ data.session.remainingTime.h + ":" + data.session.remainingTime.m + ":" + data.session.remainingTime.s + " h" }}</b>
                            </td>
                          </tr>
                        </template>

                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.chargingDuration") }}:</td>
                          <td class="tableTdHalf">
                            <b> {{ data.session.durationTime.h + ":" + data.session.durationTime.m + ":" + data.session.durationTime.s + " h" }}</b>
                          </td>
                        </tr>

                        <tr>
                          <td class="tableTdHalf">{{ $t("charger.totalEnergy") }}:</td>
                          <td class="tableTdHalf">
                            <b>{{ data.energyP.energy }} kWh</b>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <br />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </template>
    </template>

    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import ChargerGauge from "../../components/charts/ChargerGauge.vue";
import BatterySoC from "../../components/battery/BatterySoC.vue";
import LoadingData from "../../components/LoadingData.vue";

import { svgGaugeColors } from "../../colors.js";
import { mapState } from "vuex";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "EVCSDashboard",
  components: {
    BatterySoC,
    ChargerGauge,
    LoadingData,
  },
  data() {
    return {
      icons: {
        padding: 48,
        minSize: 24,
        maxSize: 220,
      },

      arrows: {
        padding: 1000,
        value: 2,
        min: 4,
        max: 24,
        minSize: 24,
        maxSize: 125,
      },

      currentSizeIcons: {
        fontSize: 20 + "px",
        size: 20,
      },

      currentSizeArrows: {
        fontSize: 80 + "px",
        size: 80,
      },

      currentParameters: {
        maxCurrent: 0,
        maxUserCurrent: 0,
        nominalPower: 0,
      },

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      user: JSON.parse(sessionStorage.getItem("user")),

      tableView: false,

      dataTableChargersHeader: [
        {
          text: this.$i18n.t("charger.name"),
          value: "name",
          width: "2%",
        },
        {
          text: this.$i18n.t("charger.state"),
          value: "stateDesc",
          width: "2%",
        },
        {
          text: this.$i18n.t("charger.power") + " [kW]",
          value: "power",
          width: "2%",
          align: " d-none d-lg-table-cell",
        },
        {
          text: this.$i18n.t("charger.energy") + " [kWh]",
          value: "energy",
          width: "2%",
          align: " d-none d-lg-table-cell",
        },
        {
          text: this.$i18n.t("charger.durationTime") + " [h]",
          value: "durationTime",
          width: "2%",
          align: " d-none d-lg-table-cell",
        },
        {
          text: this.$i18n.t("charger.serialNumberLong"),
          value: "serialNumber",
          width: "2%",
        },
      ],

      dataTableChargersItems: [],

      chargingControl: {
        start: false,
        iddle: false,
        stop: false,
      },

      svgGaugeData: {
        value: 0,
      },

      mobile: false,

      stationCardMaxWidth: 0,

      response: 0,

      data: null,

      timerStation: null,
      timerStationsSessions: null,

      station: null,
      stations: null,

      totalChargingPower: 0,
      totalConsumingPower: 0,

      charging: true,

      timeChargingStarted: 0,

      maximumPower: 22,
      maximumEnergy: 44,

      color1: [
        { offset: 0, color: svgGaugeColors.charger[0] },
        { offset: 20, color: svgGaugeColors.charger[1] },
        { offset: 40, color: svgGaugeColors.charger[2] },
        { offset: 80, color: svgGaugeColors.charger[3] },
        { offset: 100, color: svgGaugeColors.charger[4] },
      ],

      dataTableHeaders: [
        {
          text: this.$i18n.t("charger.initialDateTime"),
          value: "initialDateTime",
          width: "2%",
        },
        {
          text: this.$i18n.t("charger.name"),
          value: "name",
          width: "1%",
        },
        /*         {
          text: this.$i18n.t("charger.unitId"),
          value: "unitId",
          width: "1%",
        }, */
        /*         {
          text: this.$i18n.t("charger.id"),
          value: "id",
          width: "1%",
        }, */
        /*         {
          text: this.$i18n.t("charger.flags"),
          value: "flags",
          width: "1%",
        }, */
        /*         {
          text: this.$i18n.t("charger.flagsDesc.header"),
          value: "flagsDesc2",
          width: "1%",
        }, */
        {
          text: this.$i18n.t("charger.flagsDesc.header"),
          value: "flagsDesc",
          width: "1%",
        },
        /*         {
          text: this.$i18n.t("charger.initialEnergy") + " [kWh]",
          value: "initialEnergy",
          width: "2%",
        }, */
        {
          text: this.$i18n.t("charger.durationTime") + " [h]",
          value: "durationTime",
          width: "1%",
        },
        {
          text: this.$i18n.t("charger.energy") + " [kWh]",
          value: "energy",
          width: "1%",
        },
        /*         {
          text: this.$i18n.t("charger.carSOC"),
          value: "carSOC",
          width: "1%",
        }, */

        /*         {
          text: this.$i18n.t("charger.userId"),
          value: "userId",
          width: "1%",
        },
        {
          text: this.$i18n.t("charger.userCredit"),
          value: "userCredit",
          width: "2%",
        }, */

        {
          text: this.$i18n.t("charger.userName"),
          value: "userName",
          width: "2%",
        },
        {
          text: this.$i18n.t("charger.confirm"),
          value: "confirm",
          width: "1%",
          sortable: false,
        },
      ],
      dataTableItems: [],

      dataTableSearch: "",
    };
  },
  computed: {
    ...mapState({
      device: (state) => state.device,
      account: (state) => state.account,
    }),
  },
  created() {
    this.getBreakpoints();
    this.calculateCurrentIconsSize(this.windowWidth, this.icons.padding, this.icons.minSize, this.icons.maxSize);
    this.setArrowSize(this.currentSizeIcons.size, this.arrows.minSize, this.arrows.maxSize);
    this.calculateNumberOfArrows(this.windowWidth, this.arrows.padding, this.arrows.min, this.arrows.max);

    this.getStations();
    this.getSessions();
  },
  mounted() {
    this.pollStationsAndSessions();

    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    getStations() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("evcstations"), null, null, "GET")
        .then((data) => {
          this.stations = data;

          if ("external" in this.stations) {
            this.totalChargingPower = 0;
            this.totalConsumingPower = 0;

            if ("totalChargingPower" in this.stations.external) {
              this.totalChargingPower = this.stations.external.totalChargingPower;
            } else {
              for (let index = 0; index < this.stations.units.length; index++) {
                this.totalChargingPower += this.stations.units[index].power;
              }
            }

            this.totalChargingPower = this.totalChargingPower.toFixed(3);

            this.totalConsumingPower += this.stations.external.p1 > 0 ? this.stations.external.p1 : 0;
            this.totalConsumingPower += this.stations.external.p2 > 0 ? this.stations.external.p2 : 0;
            this.totalConsumingPower += this.stations.external.p3 > 0 ? this.stations.external.p3 : 0;

            this.totalConsumingPower = this.totalConsumingPower.toFixed(3);
          }

          this.dataTableChargersItems = data.units;

          for (let i = 0; i < this.dataTableChargersItems.length; i++) {
            if (!("name" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].name = "N/A";
            }
            if (!("stateDesc" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].stateDesc = "N/A";
            }
            if (!("power" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].power = "N/A";
            }
            if (!("energy" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].energy = "N/A";
            }
            if (!("durationTime" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].durationTime = "N/A";
            }
            if (!("serialNumber" in this.dataTableChargersItems[i])) {
              this.dataTableChargersItems[i].serialNumber = "N/A";
            }
          }

          if ("units" in this.stations) {
            for (let index = 0; index < this.stations.units.length; index++) {
              if ("durationTime" in this.stations.units[index]) {
                this.stations.units[index].durationTime = this.secondsToHHMMSS(this.stations.units[index].durationTime);
              }
            }
          }
        })
        .catch((error) => {
          this.stations = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getStation(station) {
      this.station = station;

      let parameters = "?" + "unitid" + "=" + station;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("evcstation"), null, parameters, "GET")
        .then((data) => {
          this.data = data;

          if ("parameters" in this.data) {
            if ("maxCurrent" in this.data.parameters) {
              this.currentParameters.maxCurrent = this.data.parameters.maxCurrent;
            }
            if ("maxUserCurrent" in this.data.parameters) {
              this.currentParameters.maxUserCurrent = this.data.parameters.maxUserCurrent;
            }
            if ("nominalPower" in this.data.parameters) {
              this.currentParameters.nominalPower = this.data.parameters.nominalPower;
            }
          }

          if (this.data.logic.commandProcessing) {
            this.chargingControl.iddle = true;
          } else {
            this.chargingControl.iddle = false;
          }

          if ("stateDesc" in this.data.logic) {
            if (this.data.logic.stateDesc == "Connected" || this.data.logic.stateDesc == "Connected-2") {
              this.chargingControl.start = true;
            } else {
              this.chargingControl.start = false;
            }

            if (this.data.logic.stateDesc == "Charging" || this.data.logic.stateDesc == "ChargingWithVentilation" || this.data.logic.stateDesc == "Charging-2" || this.data.logic.stateDesc == "ChargingWithVentilation-2") {
              this.chargingControl.stop = true;
            } else {
              this.chargingControl.stop = false;
            }
          }

          let l = new Date(this.data.session.initialDateTime);

          this.data.session.initialDateTime =
            l.toLocaleString(this.$i18n.locale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            }) +
            " " +
            this.data.session.initialDateTime.substr(11, 5);

          if ("powerDC" in this.data) {
            if (this.data.powerDC.power == 0) {
              this.data.powerDC.power = (this.data.powerDC.u * this.data.powerDC.i) / 1000;

              this.data.powerDC.power = Math.round(this.data.powerDC.power * 100) / 100;
            }
          } else {
            if (this.data.powerP1.power == 0) {
              this.data.powerP1.power = (this.data.powerP1.u * this.data.powerP1.i) / 1000;

              this.data.powerP1.power = Math.round(this.data.powerP1.power * 100) / 100;
            }

            if (this.data.powerP2.power == 0) {
              this.data.powerP2.power = (this.data.powerP2.u * this.data.powerP2.i) / 1000;

              this.data.powerP2.power = Math.round(this.data.powerP2.power * 100) / 100;
            }

            if (this.data.powerP3.power == 0) {
              this.data.powerP3.power = (this.data.powerP3.u * this.data.powerP3.i) / 1000;

              this.data.powerP3.power = Math.round(this.data.powerP3.power * 100) / 100;
            }
          }

          let n = 0;

          if ("powerDC" in this.data) {
            if (this.data.powerDC.power != 0) {
              n++;
            }
          } else {
            if (this.data.powerP1.power != 0) {
              n++;
            }
            if (this.data.powerP2.power != 0) {
              n++;
            }
            if (this.data.powerP3.power != 0) {
              n++;
            }
          }

          if (n < 1) {
            n = 1;
          } else if (n > 3) {
            n = 3;
          }

          if ("parameters" in this.data) {
            this.maximumPower = Math.round(n * this.data.parameters.nominalPower);
          } else {
            this.maximumPower = 0;
          }

          if (this.maximumPower == 0) {
            this.maximumPower = 22;
          }

          if ("powerDC" in this.data) {
            this.data.powerDC.u = Math.round(this.data.powerDC.u);
            this.data.powerDC.i = Math.round(this.data.powerDC.i * 10) / 10;
          } else {
            this.data.powerP1.u = Math.round(this.data.powerP1.u);
            this.data.powerP2.u = Math.round(this.data.powerP2.u);
            this.data.powerP3.u = Math.round(this.data.powerP3.u);

            this.data.powerP1.i = Math.round(this.data.powerP1.i * 10) / 10;
            this.data.powerP2.i = Math.round(this.data.powerP2.i * 10) / 10;
            this.data.powerP3.i = Math.round(this.data.powerP3.i * 10) / 10;
          }

          this.data.session.durationTime = this.secondsToHHMMSS(this.data.session.durationTime);

          if ("remainingTime" in this.data.session) {
            this.data.session.remainingTime = this.secondsToHHMMSS(this.data.session.remainingTime);
          }

          this.data.energyP.power = Math.round(this.data.energyP.power * 100) / 100;

          this.data.energyP.power = Math.abs(this.data.energyP.power);

          if (this.data.energyP.power > this.maximumPower) {
            this.maximumPower = this.data.energyP.power;
            this.maximumPower = Math.round(this.maximumPower);
          }

          this.svgGaugeData.value = (this.data.energyP.power * 100) / this.maximumPower;
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getSessions() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("evcsessions"), null, null, "GET")
        .then((data) => {
          this.dataTableItems = data.sessions;

          for (let index = 0; index < this.dataTableItems.length; index++) {
            this.dataTableItems[index].durationTime = this.secondsToHHMMSS(this.dataTableItems[index].durationTime);

            this.dataTableItems[index].durationTime = this.dataTableItems[index].durationTime.h + ":" + this.dataTableItems[index].durationTime.m + ":" + this.dataTableItems[index].durationTime.s;

            let l = new Date(this.dataTableItems[index].initialDateTime);

            this.dataTableItems[index].initialDateTime =
              l.toLocaleString(this.$i18n.locale, {
                year: "numeric",
                month: "long",
                day: "numeric",
              }) +
              " " +
              this.dataTableItems[index].initialDateTime.substr(11, 5);

            if (this.dataTableItems[index].flagsDesc == "Active") {
              this.dataTableItems[index].enabled = false;
            } else {
              this.dataTableItems[index].enabled = true;

              if (this.dataTableItems[index].flagsDesc == "Closed") {
                this.dataTableItems[index].confirm = true;
              }

              if (this.dataTableItems[index].flagsDesc == "Inactive") {
                this.dataTableItems[index].confirm = false;
              }
            }

            this.dataTableItems[index].flagsDesc2 = this.$t("charger.flagsDesc." + this.dataTableItems[index].flagsDesc);
          }
        })
        .catch((error) => {
          this.dataTableItems = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    setSession(session, value) {
      let parameters = "?" + "id" + "=" + session + "&confirm" + "=" + value;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("evcsession"), null, parameters, "GET")
        .then(() => {
          this.getSessions();
        })
        .catch((error) => {
          ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    pollStation() {
      this.timerStation = setInterval(() => {
        this.getStation(this.station);
      }, 2000);
    },
    pollStationsAndSessions() {
      this.timerStationsSessions = setInterval(() => {
        this.getStations();
        this.getSessions();
      }, 5000);
    },
    resetStation() {
      this.station = null;
    },
    refreshTimerStation() {
      if (this.timerStation == null) {
        this.pollStation();
      }
    },
    stopTimerStation() {
      if (this.timerStation != null) {
        clearInterval(this.timerStation);
        this.timerStation = null;
      }
    },
    sendCurrent(value) {
      let parameters = "?unitid=" + this.station + "&usermaxcurrent=" + value;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("evcparams"), null, parameters, "GET")
        .then(() => {
          this.refreshTimerStation();
        })
        .catch((error) => {
          this.refreshTimerStation();

          ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    sendCommand() {
      let parameters = "?" + "unitid" + "=" + this.station;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("evccommand"), null, parameters, "GET")
        .then(() => {
          this.getStation(this.station);
        })
        .catch((error) => {
          ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    calculateNumberOfArrows(width, padding, min, max) {
      this.arrows.value = Math.floor((width - padding) / this.currentSizeArrows.size);

      this.limitateNumberOfArrows(min, max);
    },
    setArrowSize(value, minSize, maxSize) {
      let l = value / 3;

      this.currentSizeArrows.fontSize = l + "px";
      this.currentSizeArrows.size = l;

      this.limitateCurrentArrowSize(minSize, maxSize);
    },

    calculateCurrentIconsSize(width, padding, minSize, maxSize) {
      let l = (width - padding) / 3;

      this.currentSizeIcons.fontSize = l + "px";
      this.currentSizeIcons.size = l;

      this.limitateCurrentIconsSize(minSize, maxSize);
    },
    limitateNumberOfArrows(min, max) {
      if (this.arrows.value > max) {
        this.arrows.value = max;
      } else if (this.arrows.value < min) {
        this.arrows.value = min;
      }
    },
    limitateCurrentArrowSize(min, max) {
      if (this.currentSizeArrows.size > max) {
        this.currentSizeArrows.fontSize = max + "px";
        this.currentSizeArrows.size = max;
      }
      if (this.currentSizeArrows.size < min) {
        this.currentSizeArrows.fontSize = max + "px";
        this.currentSizeArrows.size = min;
      }
    },
    limitateCurrentIconsSize(min, max) {
      if (this.currentSizeIcons.size > max) {
        this.currentSizeIcons.fontSize = max + "px";
        this.currentSizeIcons.size = max;
      }
      if (this.currentSizeIcons.size < min) {
        this.currentSizeIcons.fontSize = min + "px";
        this.currentSizeIcons.size = min;
      }
    },
    setChargersTableView(bool) {
      this.tableView = bool;
    },
    /*     getStationsRowStyles(row) {

      

      if (row.stateDesc == "InUse") {
        return "";
      } else {
        return "";
      }
    }, */
    handleClick(row) {
      if (row.stateDesc == "InUse") {
        return;
      } else {
        this.station = row.unitId;
        this.getStation(this.station);
      }
    },
    secondsToHHMMSS(secs) {
      var hours = Math.floor(secs / 3600);

      var m = secs % 3600;
      var minutes = Math.floor(m / 60);

      var s = m % 60;
      var seconds = Math.ceil(s);

      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }

      var obj = {
        h: hours,
        m: minutes,
        s: seconds,
      };
      return obj;
    },
    getColor() {
      return "primary";
    },
    getConfirmColor(item) {
      let confirmedIndex = this.dataTableItems.indexOf(item);

      if (this.dataTableItems[confirmedIndex].confirm) {
        return "primary";
      } else {
        return "grey";
      }
    },
    getFlagsDescColor(item) {
      let confirmedIndex = this.dataTableItems.indexOf(item);

      if (this.dataTableItems[confirmedIndex].flagsDesc == "Active") {
        return "cyan darken-2";
      } else if (this.dataTableItems[confirmedIndex].flagsDesc == "Inactive") {
        return "red darken-2";
      } else if (this.dataTableItems[confirmedIndex].flagsDesc == "Closed") {
        return "light-green darken-2";
      }
    },
    toggleConfirm(item) {
      let confirmedIndex = this.dataTableItems.indexOf(item);

      this.dataTableItems[confirmedIndex].confirm = !this.dataTableItems[confirmedIndex].confirm;

      this.setSession(this.dataTableItems[confirmedIndex].id, this.dataTableItems[confirmedIndex].confirm);
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.stationCardMaxWidth = this.windowWidth - (48 + 24);
        this.mobile = true;
      } else {
        this.stationCardMaxWidth = 330;
        this.mobile = false;
      }
    },
    onResize() {
      this.getBreakpoints();
      this.calculateCurrentIconsSize(this.windowWidth, this.icons.padding, this.icons.minSize, this.icons.maxSize);
      this.setArrowSize(this.currentSizeIcons.size, this.arrows.minSize, this.arrows.maxSize);
      this.calculateNumberOfArrows(this.windowWidth, this.arrows.padding, this.arrows.min, this.arrows.max);
    },
  },
  beforeDestroy() {
    clearInterval(this.timerStation);
    clearInterval(this.timerStationsSessions);

    window.removeEventListener("resize", this.onResize);
  },
  destroyed() {},
  watch: {
    station: function () {
      this.stopTimerStation();

      if (this.station == null) {
        return;
      }

      this.refreshTimerStation();

      this.getStation(this.station);
    },
  },
};
</script>

<style scoped>
.myTable.highlight:hover {
  color: #ff0000;
}

.arrows {
  max-height: 200px;
}

.tableTdHalf {
  width: 50%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
}

.tableTdQuarter {
  width: 25%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
}

.tableTdSixth {
  width: 16.66%;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
}

.socValue {
  position: absolute;
  left: 75%;
  top: 45%;
}

.socValueMobile {
  position: absolute;
  left: 75%;
  top: 45%;
}

.v-card--reveal {
  border-radius: 5px;

  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}

.shadow {
  text-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.animationCharge {
  position: relative;
  animation: fastCharge 2.5s linear infinite;
  animation-direction: normal;
  animation-fill-mode: forwards;
}

.animationNoCharge {
  position: relative;
  animation: fastCharge 2.5s linear infinite;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: paused;
}

@keyframes fastCharge {
  0% {
    left: -80px;
    top: 0px;
    opacity: 1;
    visibility: visible;
  }
  50% {
    opacity: 1;
    visibility: visible;
  }
  100% {
    opacity: 0;
    visibility: hidden;
    left: 80px;
    top: 0px;
  }
}

.darkTable {
  background-color: #121212;
}
.lightTable {
  background-color: white;
}
</style>
